import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-subscription-expired',
  templateUrl: './subscription-expired.component.html',
  styleUrl: './subscription-expired.component.css'
})
export class SubscriptionExpiredComponent {

  @Output() renew = new EventEmitter<void>();

  onRenew(): void {
    this.renew.emit();
  }
}